import React, { Fragment } from "react";
import { useState, useEffect, useRef } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Checkmark} from 'react-checkmark';


import { loadSanadBranding } from "../utils/loadSanadBranding";

const { config } = require("../../api/api");


const SanadMotorPolicyStatus = () => {

       
        const base_url = config.baseURL;
        const redirect_url=config.redirectURL;
      
        const [loading,setLoading]=useState(true);
    
        const [quoteNo,setQuoteNo]=useState("");
        const vendor_key = 'c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==';
    
        const [quoteDetails,setQuoteDetails]=useState(null);
        const [vehicleDetails,setVehicleDetails]=useState(null);
        const [insuredDetails,setInsuredDetails]=useState(null);
        const [transactionDetails,setTransactionDetails]=useState(null);

        const [policyDocs,setPolicyDocs]=useState(null)

        const [openPolicyStatus,setOpenPolicyStatus]=useState(false);
        const [paymentStatus,setPaymentStatus]=useState("");
        const [startTimer,setStartTimer]=useState(0);
   
        const [openTimer,setOpenTimer]=useState(false);
        const [openMessageBox,setOpenMessageBox]= useState(false);
        const [message,setMessage]= useState("");
        const [authToken,setAuthToken]=useState("");
        const [sanadDetails,SetSanadDetails]= useState(null);            
        const [policyInfo,setPolicyInfo]=useState(null);
          
        
        const [statementUpdate,setStatementUpdate]=useState("Policy conversion in progress. This may take a few moments. Please do not refresh.")
        
        useEffect(() => {
    
        loadSanadBranding();
    
      }, [])

 useEffect(() => {
    // debugger;

    const params = new URLSearchParams(window.location.search); 
    const quote_no = params.get("q_no");
    const payment_status = params.get("payment_status");
    setQuoteNo(quote_no);
    // setPaymentStatus(payment_status);

  }, []);

    
  let count = 0;







  
 useEffect(() => {
  // debugger
  if (!quoteNo) return;

  const searchQuote = async (payload, sanad_policy_data) => {
    try {
      const response = await fetch(`${base_url}/search_quote`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendor_key}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        console.log("searching quote HTTP status:", response.status);
        return null;
      }

      const data = await response.json();

      if (data?.result?.effectiveDt && data?.result?.insuredDetails) {
        const policy_details = sanad_policy_data?.result || {};

        data.result = {
          ...data.result,
          premiumAmt: policy_details.premium_amount,
          planSelected: policy_details.plan_selection,
          paymentStatus: policy_details.payment_status,
        };

        setQuoteDetails(data.result);
        setVehicleDetails(data.result.vehicleDetails);
        setInsuredDetails(data.result.insuredDetails);
        setTransactionDetails(data.result.transactionDetails || null);
        setOpenPolicyStatus(true);

        return data.result.transactionDetails?.policyNo || null;
      }

      return null;
    } catch (err) {
      console.error("Error in search quote api:", err);
      return null;
    }
  };

  const getPolicyDetails = async () => {
    try {
      // debugger
      const response = await fetch(`${base_url}/get_sanad_motor_policy_details`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendor_key}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ quoteNo }),
      });

    if (!response.ok) {
    console.log("Getting policy details HTTP status:", response.status);
    throw new Error("No policy found");
    // return null; // unreachable, can remove
}


      return await response.json();
    } catch (err) {
      // debugger
      if(err.message==="No policy found"){
        setOpenMessageBox(true);
        setMessage(err.message);
      }
      console.error("Error in get policy details api:", err);
      return null;
    }
  };

  const getPolicyDoc = async (payload) => {
    try {
      const response = await fetch(`${base_url}/get_policy_doc`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendor_key}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        console.log("policy doc HTTP status:", response.status);
        return;
      }

      const data = await response.json();
      if (data.message === "success" && data.result?.length > 0) {
        setPolicyDocs(data.result);
      }
    } catch (err) {
      console.error("Error in get policy doc api:", err);
    }
  };

  const callFunction = async () => {
    try {
      

      const get_policy_info = await getPolicyDetails();
        var sanad_policy_data = get_policy_info;
        
        setPaymentStatus(get_policy_info.result.payment_status);
        setPolicyInfo(get_policy_info.result);


      if (get_policy_info?.message === "success" && get_policy_info.result.payment_status==="success") {

        const fetchAndSetPolicyDoc = async () => {
             setLoading(true);
          const policy_payload = {
        civilId: "",
        plateNo: "",
        registrationMark: "",
        srcBusId: "SJET",
        txnTyp: "P",
        mobileNo: "",
        policyNo: "",
        quoteNo,
        searchTyp: "",
      };
          const policy_no = await searchQuote(policy_payload, sanad_policy_data);
          if (policy_no && policy_no.includes("P")) {
            // await getPolicyDoc({
            //   civilId: "",
            //   plateNo: "",
            //   registrationMark: "",
            //   srcBusId: "SJET",
            //   mobileNo: "",
            //   policyNo: policy_no,
            // });
            return policy_no;
          }
          
          return null;
        };

        SetSanadDetails(get_policy_info.result.sanad_details);


        //end
// debugger
        // case 1: policy_no is available (not pending and not null)
        if ( get_policy_info.result.policy_no !== "pending" && get_policy_info.result.policy_no.includes("P")) {
          await fetchAndSetPolicyDoc();
          setLoading(false);
          setOpenTimer(false);
        } else {
          // case 2: wait for 30 seconds then retry
          setStartTimer(40);
          console.log("timer : ",startTimer);
          setOpenTimer(true)
        const checkPolicy = async () => {
  count++;

  const get_policy_no = await fetchAndSetPolicyDoc();
  if (get_policy_no) {
    setLoading(false);
    setOpenTimer(false);
    return; // stop here (no more recursion)
  }

  if (count === 1) {
     setStartTimer(25);
    setStatementUpdate("Your policy conversion is still processing, taking longer than usual. Please wait.");
    setTimeout(checkPolicy, 25000);
  }
  if(count ===2){
       setStartTimer(15);
    setStatementUpdate("Policy conversion is in progress; final step may require additional processing time.");
    setTimeout(checkPolicy, 15000);
  }
  if (count === 3) {

    setLoading(false);
    setOpenTimer(false);
    setStartTimer(0);
    setOpenMessageBox(true);
    setMessage("The request cannot be completed at the moment. Please try again.")
    return; // stop after 2 tries
  }

  // schedule next check after 35s
  
};
   
          setTimeout(checkPolicy,40000);

        }
      }
      else if(get_policy_info?.message === "success" && get_policy_info.result.payment_status!=="success"){
  const policy_payload = {
        civilId: "",
        plateNo: "",
        registrationMark: "",
        srcBusId: "SJET",
        txnTyp: "Q",
        mobileNo: "",
        policyNo: "",
        quoteNo,
        searchTyp: "",
      };
       await searchQuote(policy_payload, sanad_policy_data);
}
    } catch (err) {
      console.error("Error in callFunction:", err);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  callFunction();
}, [quoteNo]);




const handleRetryPayment=async(e)=>{
  // payment api 
  e.preventDefault();

      const payment_data={
      "quoteNo":quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo,
      "amount": quoteDetails.premiumAmt
  }
  
    const response = await fetch(base_url+"/sanad_motor_ins_payments",{
    method:"POST",
    headers:{
      "Authorization": `Bearer ${vendor_key}`,
      "Content-Type": "application/json"
    },
    body:JSON.stringify(payment_data)
  });
  if(!response.ok){
    console.log("payment fetch HTTP status :", response.status);
    }
  
    const payment_response = await response.json();
  
    if(payment_response.message==="success"){
  
      if(payment_response.result.success && payment_response.result.message==="Payment Link Generated Successfully" ){
  
        const url = payment_response.result.data
  
        if(url){
  
            window.location.href=url;
        }
  
      }
    }
    else{
      toast.error("Payment process not initiated");
    }
  
}


  const handleDocs=(e,url)=>{
    e.preventDefault();
    const element = document.createElement("a");
    element.target="_blank"
    element.href=url;
    element.click();

  }

  const handleRefresh=(e)=>{
    e.preventDefault();
    window.location.reload();
  }

useEffect(() => {
  let timer;
  if (startTimer > 0) {
    timer = setTimeout(() => {
      setStartTimer((prev) => prev - 1);
    }, 1000);
  }

  return () => clearTimeout(timer); // cleanup on re-render/unmount
}, [startTimer]);



    
        return (
        <>


        
 {/* { <div className={`row mt-5 ${paymentStatus!=="success"?"d-flex justify-content-center":""}`} style={{alignContent:"center"}}> */}
 { <div className={`row mt-5 d-flex justify-content-center`} style={{alignContent:"center"}}>

{(paymentStatus==="success" &&transactionDetails?.policyNo) && <div  className="col-12">
  <div className="d-flex justify-content-end ">
    <button className="mr-5" 
       onClick={() => {
                            // debugger
                            const regex = /^(ftp|http|https):\/\/[^ "]+$/;
                            var isValidUrl = regex.test(sanadDetails?.return_url);

                            if (isValidUrl) {
                              window.location.href =
                                sanadDetails?.return_url +
                                '?policyno=' + (transactionDetails?.policyNo || policyInfo?.policy_no)  +
                                '&sanad_reference_no=' + policyInfo?.sanad_reference_no 
                              
                            } else {
                              window.location.reload();
                            }
    }}
    >Go To Sanad</button>
  </div></div>}
     
 {  (openPolicyStatus && quoteDetails)  && <div className={`col-lg-6 mt-3`} style={{marginBottom:"80px"}}>
    <div className="card shadow p-4 mx-3 ">
    <div className=' d-flex justify-content-between my-2 '>
    
                                          <h1>
                                       <span style={{display:"inline-block",position:"relative",top:"2px"}}>
                                        { paymentStatus==="success"?
                                         <><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="green" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg></>:
                                        <><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x-icon lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg></> }
                            </span>&nbsp;Policy Status </h1>
                                    
                                      <h1>
                                    حالة السياسة
                                    </h1>
                                    
                                      </div>
                                   
    

    <table className="w-100 px-2">
    <tbody >
        {paymentStatus==="success" && <tr>
            <td className='border px-2 py-2'>
    {'Policy No'}
            </td>
            <td className='border px-2 py-2'>
    {transactionDetails?.policyNo}  
            </td>
        </tr>}
        <tr>
            <td className='border px-2 py-2'>
    {'Quote No'}
            </td>
            <td className='border px-2 py-2'>
               {transactionDetails?.quoteNo}  

            </td>
        </tr>
           <tr>
            <td className='border px-2 py-2'>
    {'Sanad Reference No'}
            </td>
            <td className='border px-2 py-2'>
               {policyInfo ? policyInfo?.sanad_reference_no:""}  

            </td>
        </tr>
         <tr>
            <td className='border px-2 py-2'>
    {'Cover From Date'}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails?.effectiveDt}  
            </td>
        </tr>
          <tr >
            <td className='border px-2 py-2'>
    {'Cover To Date'}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails?.expirationDt}  
            </td>
        </tr>
          <tr >
            <td className='border px-2 py-2'>
    {'Insured Name'}
            </td>
            <td className='border px-2 py-2'>
               {insuredDetails?.insureFullName}  
            </td>
        </tr>

         <tr >
            <td className='border px-2 py-2'>
    {'Plate No'}
            </td>
            <td className='border px-2 py-2'>
               {vehicleDetails?.vehRegNo}  
            </td>
        </tr>
        <tr >
            <td className='border px-2 py-2'>
    {'Plate Code'}
            </td>
            <td className='border px-2 py-2'>
               {vehicleDetails?.vehRegLOC}  
            </td>
        </tr>

          <tr >
            <td className='border px-2 py-2'>
    {'Premium'}
            </td>
            <td className='border px-2 py-2'>
               { quoteDetails.premiumAmt +" OMR"}  
            </td>
        </tr>
          <tr>
            <td className='border px-2 py-2'>
    {'Product'}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails?.prodId}  
            </td>
        </tr>
        <tr>
            <td className='border px-2 py-2'>
    {'Plan'}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails?.planSelection ||quoteDetails.planSelected}  
            </td>
        </tr>
        <tr>
            <td className='border px-2 py-2'>
    {'Payment Status'}
            </td>
            <td className='border px-2 py-2'>
               {quoteDetails.paymentStatus}  
            </td>
        </tr>
    </tbody>
    </table>


    </div>

    {
      paymentStatus !=="success" || quoteDetails.paymentStatus !=="success"?
      <div className="text-center"> <button type="button" className="mt-3" onClick={(e)=>handleRetryPayment(e)}>Retry Payment</button>
      </div>:
      ""
    }
           </div>    
                    
  }
    
   {/* {(policyDocs && policyDocs?.length>0 )&& <div className="col-lg-6 mt-3" style={{marginBottom:"80px"}}>
        <div className='card shadow p-4 mx-3 '>
    <div className=' d-flex justify-content-between mb-2'>
    
                                          <h1>Policy Documents</h1>
                                    
                                      <h1>
                                    وثائق السياسة
                                    </h1>
                                    
                                      </div>
                                    
        <div className=" d-flex  px-3 py-4 ">
        <div className="row">
       { policyDocs?.length>0 &&
       
       policyDocs.map((docs)=>(

        <div className="col-6 mb-4">
       <h3> {docs.name.replace(" - 0","")}</h3>
      
       <button className="w-75"  style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}
       onClick={(e)=>handleDocs(e,docs.url)}>
              <span className="d-inline=-block " style={{position:"relative",top:"3px"}}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
</svg></span><span style={{marginLeft:"10px"}}>  {docs.url.substring(docs.url.lastIndexOf("=")+1,docs.url.length)} </span>
       </button>
   
        </div>
        ))}
        </div>
        </div>
          </div>  
    </div>
    } */}
    </div>
    }


    {/* {
      (!openPolicyStatus && !loading )&&
      <>
      <div className="row" style={{height:"80vh",justifyContent:"center",alignContent:"center"}}>
      <div>
      <h1>Try again</h1>


      <div className="w-100 mt-3 d-flex justify-content-center">
      <button className="" onClick={(e)=>handleRefresh(e)}>
      Refresh
      </button>
      </div>
      </div>
      </div>
      </> 
    } */}
{
  openMessageBox  && (
        <div className='modal'>
          <div className='modal-content' style={{height: "auto" , width:'600px'}}>
         
          {/* <button type="button" className="close" onClick={handleClose}>
          &times;
          </button> */}
          
          <div>
          <div style={{textAlign:"left"}}>{message}</div>
          
          <hr></hr>
          <div>
          {
            message!=="No policy found"&&
          <button type="button" className="mt-3" aria-label="Close" onClick={handleRefresh}>Try again</button>
          }
          </div>

          </div>
          </div>
        </div>
      )
}

   {
      (openTimer && startTimer>0) &&  
      <>
      <div className="row" style={{height:"75vh",justifyContent:"center",alignContent:"center"}}>
      <div>

      <div className="d-flex justify-content-center mb-2">
      <img src="/gifs/file_preparing.gif" alt="Preparing..." style={{width:"70px"}} />

      </div>
      <h1 className="d-flex justify-content-center " style={{fontWeight:"600"}}>{startTimer}&nbsp;Secs</h1>


      <div className=" mx-5 mt-3 d-flex justify-content-center">
      <h3>
     {statementUpdate}
     </h3>
      </div>
      </div>
      </div>
      </>
    }

    {
      (!openTimer && loading) && (
            <div className="overlay">
              <div className="spinner">
              </div>
            </div>
          )
    }
    
        </>
        
        )
    
}

export default SanadMotorPolicyStatus;